module.exports = __webpack_public_path__ + "static/media/noInputFlows.dfa8b7de.svg";